import React from 'react';

export interface ErrorStateProps {
    message: string;
}

const LoadingError: React.FunctionComponent<ErrorStateProps> = ({ message }) => {
    return (
        <div className="dx-empty-state">
            <div className="dx-empty-state__icon">
                <div className="dx-spinner" />
            </div>
            <h4 className="dx-empty-state__title">Loading cluster information</h4>
            <div className="dx-empty-state__body">
                <div className="dx-stack">
                    {message}
                </div>
            </div>
        </div>
    );
};

export default LoadingError;
